<template>
  <div class="fy-product-content">
    <div class="fy-drawer" v-if="IsMobile">
      <div class="fy-drawer__logo">
        <img :src="cpxlMIcon" />
      </div>
      <div class="fy-drawer__list">
        <div class="fy-drawer__item" :class="{'fy-drawer__item_chose':choseType === item.type}" v-for="item in productList" :key="item.name" @click="productItemClick(item.type, item.name)">
          <div class="fy-drawer__item__nameZh">{{ item.nameZh }}</div>
          <div class="fy-drawer__item__name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <ul class="products-image__list">
      <li v-for="(products, index) in productsList" :key="index" class="products-image__list_item">
        <div class="products-image__list_item_img">
          <router-link :to="`/products_detail?id=${products.id}&type=${products.type}&size=${(index & 1) === 0 ? 'horizontal' : 'vertical'}`">
            <img v-lazy="(index & 1) === 0 ? products.horizontalImg : products.verticalImg" />
            <div class="products-image__list_item_img_info">
              <div>{{(index & 1) === 0 ? products.horizontalName : products.name}}</div>
            </div>
          </router-link>
        </div>
        <div class="products-image__list_item_img">
          <router-link :to="`/products_detail?id=${products.id}&type=${products.type}&size=${(index & 1) === 0 ? 'vertical' : 'horizontal'}`">
            <img v-lazy="(index & 1) === 0 ? products.verticalImg : products.horizontalImg" />
            <div class="products-image__list_item_img_info">
              <div>{{(index & 1) === 0 ? products.name : products.horizontalName}}</div>
            </div>
          </router-link>
        </div>
      </li>
    </ul>
    <div class="fy-introduction" v-if="!IsMobile">
      <div class="fy-drawer" :style="{padding: 0}">
        <div class="fy-drawer__logo">
          <img :src="cpxlIcon" />
        </div>
        <div class="fy-drawer__list">
          <div v-for="item in productList" :key="item.name" @click="productItemClick(item.type, item.name)" class="fy-drawer__item" :class="{'fy-drawer__item_chose':choseType === item.type}">
            <div class="fy-drawer__item__nameZh">{{ item.nameZh }}</div>
            <div class="fy-drawer__item__name">{{ item.name }}</div>
          </div>
        </div>
        <div class="fy-drawer__bottom">
          <img :src="drawerBottomIcon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import dayjs from "dayjs";
import { IsMobile } from "@/utils";
import cpxlIcon from "@/assets/cpxl—icon.png";
import cpxlMIcon from "@/assets/cpxl-m-icon.png";
import drawerBottomIcon from "@/assets/drawer-bottom-icon@3x.png";
export default Vue.extend({
  name: "Products",
  data() {
    return {
      productsList: [],
      IsMobile,
      productList: [
        {
          name: "清新系列",
          nameZh: "FRESH COllECTION",
          type: "fresh",
        },
        {
          name: "法式系列",
          nameZh: "FRENCH COllECTION",
          type: "french",
        },
        {
          name: "经典系列",
          nameZh: "CLASSIC COllECTION",
          type: "classic",
        },
        {
          name: "镭射系列",
          nameZh: "LASER COllECTION",
          type: "laser",
        },
        {
          name: "纯色系列",
          nameZh: "PURE COllECTION",
          type: "pure",
        },
        {
          name: "磨砂系列",
          nameZh: "FROSTED COllECTION",
          type: "frosted",
        },
        {
          name: "点钻系列",
          nameZh: "DIAMOND COllECTION",
          type: "diamond",
        },
      ],
      cpxlIcon,
      cpxlMIcon,
      choseType: "fresh",
      drawerBottomIcon,
    };
  },
  methods: {
    getList(type) {
      this.$https
        .get("/api/oilliProduct/getListForweb", {
          params: {
            type: type || "fresh",
          },
        })
        .then((res) => {
          this.productsList = res.data.items;
          console.log(res.data.items);
        });
    },
    dayFormat(time) {
      return dayjs(time).format("YYYY.MM.DD");
    },
    productItemClick(type, name) {
      this.showDrawer = false;
      this.$router.push({
        path: "/products",
        query: {
          type,
          name,
        },
      });
    },
  },
  watch: {
    "$route.query.type": {
      handler(val) {
        this.choseType = val || "fresh";
        this.getList(val || "fresh");
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法，如果设置了false，那么效果和上边例子一样
      immediate: true,
    },
  },
});
</script>